import styled from 'styled-components'

export const SmallerContainer = styled.div`
	max-width: 1050px;
	margin: 0 auto;

	@media (max-width: 992px) {
		width: 90%;
	}
`
